import { render, staticRenderFns } from "./TextAreaComponent.vue?vue&type=template&id=af367bb4&scoped=true&"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaComponent.vue?vue&type=style&index=0&id=af367bb4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af367bb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCol,VTextarea})
